import { useEffect, useState } from 'react'
import { BREAKPOINT } from './tokens'

/**
 * 宽窄判定 —— 与 BREAKPOINT 同住 theme，改断点只改 tokens.ts 一处。
 *
 * 为什么不放进 JSS 的 media query 就够了：顶栏要在窄屏下**换结构**（不是换样式），
 * 三键 + 抽屉 vs 一排键，DOM 得真的不一样，所以必须有 JS 侧的真值。
 *
 * 首帧取模块级常量而不是 `matchMedia` 现场求值：相同结果，但省掉每个组件挂载时的同步布局查询。
 */
const isMobileInitially = window.innerWidth <= BREAKPOINT

/** 旋转屏幕、拖拽改窗口都会实时切换 */
export function useIsMobile(): boolean {
	const [isMobile, setIsMobile] = useState(isMobileInitially)
	useEffect(() => {
		const mq = window.matchMedia(`(max-width: ${BREAKPOINT}px)`)
		const onChange = () => setIsMobile(mq.matches)
		mq.addEventListener('change', onChange)
		return () => mq.removeEventListener('change', onChange)
	}, [])
	return isMobile
}
